export default "__VITE_ASSET__Bpx6ck1q__"